import { ButtonERP, CardUser, ListMenu } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useQueryClient } from "@tanstack/react-query"
import { useArticulosInvalidation } from "api/Articulo.hook"
import { putEmpresaGestionadaAsesoriaEstadoInvitacion } from "api/EmpresaGestionadaAsesoria.service"
import { GetInvitacionesAsesoriaDtoIPagedEnumerableProps } from "api/Schemas/GetInvitacionesAsesoriaDtoIPagedEnumerable"
import { TIPO_EMPRESA_USUARIO } from "api/Types/TipoEmpresa"
import {
  useGetUsuarioByCurrentUser,
  useUsuarioEmpresaActiva,
} from "api/Usuario.hook"
import ModalCierreContable from "common/components/ModalCierreContable/ModalCierreContable"
import SideBarInnova from "common/components/SideBarErp"
import ToastIntegraciones from "common/components/ToastIntegraciones/ToastIntegraciones"
import { USER_MENU_LIST } from "common/components/UserMenu/constant"
import { useNotificationsContext } from "common/context/NotificationsProvider"
import { AppContext } from "common/context/WithAppWrapper"
import useOnClickOutside from "common/hooks/useOnClickOutside"
import SendBusinessInvitation from "common/modals/SendBusinessInvitation"
import SuccessModal from "common/modals/SendBusinessInvitation/SuccessModal"
import { asesoriasInvitacionesAdapter } from "common/pages/Dashboard/asesoriasInvitaciones.adapter"
import { ModalInvitacionesAsesorias } from "common/pages/Dashboard/components/ModalInvitacionesAsesorias/ModalInvitacionesAsesorias"
import notification from "common/utils/notification"
import { logout } from "features/User/redux/slices/userSlice"
import { AnimatePresence } from "framer-motion"
import { useAsociarDocumentosInvalidation } from "hooks/useAsociarDocumentos"
import { useDispatch } from "hooks/useDispatch"
import { useFlagProtection } from "hooks/useFlagProtection"
import { useUsuarioByCurrent } from "hooks/useUsuarioByCurrent"
import { useContext, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import MdfDialog from "../../../MdfDialog"
import NotificationsMenuAllRead from "../../../NotificationsMenu/components/NotificationsMenuAllRead"
import NotificationsMenuList from "../../../NotificationsMenu/components/NotificationsMenuList"
import NotificationsMenuListFooter from "../../../NotificationsMenu/components/NotificationsMenuListFooter"
import NotificationsMenuListHeader from "../../../NotificationsMenu/components/NotificationsMenuListHeader"
import { NavbarAsesoria } from "../NavbarAsesoria"
import { AsesoriaLogo } from "./AsesoriaLogo"
import { MenuImportacionesGenerico } from "./MenuImportacionesGenerico"
import { ModalAsesoriaActiva } from "./ModalAsesoriaActiva"
import { ModalNoHayInvitacionesAsesorias } from "./ModalNoHayInvitacionesAsesorias"

export interface ManageModalAsesoriaActivaProps {
  showModalAsesoria: boolean
  deleteAsesoria: boolean
}
const NavBarRegistred = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const history = useHistory()

  // @ts-expect-error TS(2339): Property 'settings' does not exist on type 'unknow...
  const { settings } = useContext(AppContext)
  const [visibleToast, setVisibleToast] = useState(false)
  const { deleteInfiniteQueryAsociarDoc } = useAsociarDocumentosInvalidation()
  const showToastIntegraciones = useFlagProtection("show_toast_integraciones")
  const [openInvitation, setInvitation] = useState(false)
  const [completeInvitation, setCompleteInvitation] = useState(false)
  const [companyMenuOpen, setCompanyMenuOpen] = useState(false)
  const [userMenuOpen, setUserMenuOpen] = useState(false)
  const [showModalInvitacionesAsesoria, setShowModalInvitacionesAsesoria] =
    useState(false)
  const [
    showModalNoHayInvitacionesAsesoria,
    setShowModalNoHayInvitacionesAsesoria,
  ] = useState(false)

  const {
    usuario: { persona, empresaActiva, asesoriaActivaId, verificacionEmpresa },
  } = useGetUsuarioByCurrentUser()
  const isGestoriaEnabled = Boolean(
    empresaActiva?.tipoEmpresa === TIPO_EMPRESA_USUARIO.ASESORIA ||
      asesoriaActivaId
  )

  useEffect(() => {
    if (verificacionEmpresa?.verificado && showToastIntegraciones) {
      setVisibleToast(true)
      localStorage.setItem("showToastIntegration", "true")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verificacionEmpresa?.verificado])

  const handleCloseToast = () => {
    setVisibleToast(false)
  }

  const { updateAllArticulosQueries } = useArticulosInvalidation()
  const {
    activeCompany: { razonSocial, logoAsBase64, asesoria, verificada },
    activeCompanyRefetch,
  } = useUsuarioEmpresaActiva()

  const { usuarioInternoInvalidation } = useUsuarioByCurrent()
  const [manageModalAsesoriaActiva, setManageModalAsesoriaActiva] =
    useState<ManageModalAsesoriaActivaProps>({
      showModalAsesoria: false,
      deleteAsesoria: false,
    })
  const [showModalCierreContable, setShowModalCierreContable] = useState(false)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const goTo = (path: string, mode: $TSMigrationFixMe): void => {
    history.push(path, mode)
  }

  const notificationsRef = useRef<HTMLDivElement>(null)
  const companyMenuRef = useRef<HTMLDivElement>(null)
  const userMenuRef = useRef<HTMLDivElement>(null)
  const {
    openNotificationsMenu,
    hideNotifications,
    showNotifications,
    unReadNotifications,
  }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any = useNotificationsContext()

  // @ts-expect-error TS(2554): Expected 4 arguments, but got 2.
  useOnClickOutside(notificationsRef, hideNotifications)
  // @ts-expect-error TS(2554): Expected 4 arguments, but got 2.
  useOnClickOutside(companyMenuRef, () => setCompanyMenuOpen(false))
  // @ts-expect-error TS(2554): Expected 4 arguments, but got 2.
  useOnClickOutside(userMenuRef, () => setUserMenuOpen(false))

  const queryClient = useQueryClient()
  const invitacionesAsesoria =
    queryClient.getQueryData<GetInvitacionesAsesoriaDtoIPagedEnumerableProps>([
      "empresaGestionadaAsesoriaInvitacion",
    ])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleConfirmAsesoria = async (
    invitationsStatus: $TSMigrationFixMe
  ) => {
    try {
      await putEmpresaGestionadaAsesoriaEstadoInvitacion(
        invitationsStatus
      ).then(() => notification.success())
      activeCompanyRefetch()
      await queryClient.refetchQueries({
        queryKey: ["empresaGestionadaAsesoriaInvitacion"],
        exact: true,
      })
      usuarioInternoInvalidation()
      deleteInfiniteQueryAsociarDoc()
      updateAllArticulosQueries()
      history.push(ROUTES.FACTURAS)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  return (
    <>
      <div className='tw-flex tw-justify-between tw-items-center '>
        <SideBarInnova
          setInvitation={setInvitation}
          settings={settings}
          goTo={goTo}
          pathname={pathname}
        />

        <div className='tw-block lg:tw-hidden'>
          <img
            src={settings?.sidebarLogoBig}
            alt='Logo Finanedi'
            className='tw-h-6 tw-p-auto'
          />
        </div>

        <div className='tw-flex tw-items-center'>
          <div className='tw-hidden tw-h-16 tw-border-solid lg:tw-block tw-py-3 tw-px-6'>
            <ButtonERP
              customize={{
                size: "md",
                type: "secondary",
              }}
              onClick={() => {
                history.push(ROUTES.FACTURAS_FINANCIABLES)
              }}
              label={`${t("header.applyFinance")}`}
            />
          </div>

          {verificada && (
            <AsesoriaLogo
              t={t}
              logoAsBase64={asesoria?.logoAsBase64}
              razonSocial={asesoria?.razonSocial}
            />
          )}

          <div className='tw-hidden tw-h-16 tw-border-l tw-border-solid lg:tw-block'>
            <button
              type='button'
              className='tw-flex tw-justify-center tw-h-full tw-w-full tw-text-white lg:tw-text-primary hover:tw-text-secondary tw-bg-transparent tw-border-0 lg:tw-px-[27.25px] tw-cursor-pointer'
              onClick={() => setInvitation(true)}
            >
              <FontAwesomeIcon
                icon={["fal", "share-nodes"]}
                className='tw-self-center tw-w-5 tw-h-5 tw-px-2 lg:tw-px-0 tw-text-simple'
              />
            </button>
          </div>

          <div className='tw-hidden tw-h-16 tw-border-l tw-border-solid lg:tw-block'>
            <button
              type='button'
              className='tw-flex tw-justify-center tw-h-full tw-bg-transparent tw-border-0 lg:tw-mx-3'
            >
              <MdfDialog />
            </button>
          </div>

          <div className='tw-h-16 lg:tw-border-l tw-border-solid'>
            <div
              ref={notificationsRef}
              // TODO: change css notifications-menu por tailwind (C:\Users\stejeda\Desktop\Pro\BuzonDeEmpresas.Frontend\src\common\components\NotificationsMenu\style.scss)
              className='tw-relative notifications-menu tw-flex'
            >
              <div
                className='tw-flex tw-justify-center tw-h-full tw-w-full tw-text-white lg:tw-text-primary hover:tw-text-secondary tw-bg-transparent tw-border-0 lg:tw-px-[27.25px] tw-cursor-pointer'
                onClick={
                  openNotificationsMenu ? hideNotifications : showNotifications
                }
              >
                <FontAwesomeIcon
                  icon={["fal", "bell"]}
                  className='tw-self-center tw-w-5 tw-h-5 tw-px-2 lg:tw-px-0 tw-text-simple'
                />
              </div>

              <AnimatePresence>
                {openNotificationsMenu && (
                  <div className='notifications-menu-container tw-right-[-3rem] lg:tw-right-[-5.1rem] tw-top-[5rem]'>
                    <NotificationsMenuListHeader />
                    {unReadNotifications.totalCount === 0 ? (
                      <NotificationsMenuAllRead />
                    ) : (
                      <>
                        <NotificationsMenuList />
                        <NotificationsMenuListFooter />
                      </>
                    )}
                  </div>
                )}
              </AnimatePresence>
            </div>
          </div>

          <MenuImportacionesGenerico />

          <div
            ref={companyMenuRef}
            className='tw-h-16 lg:tw-border-x lg:tw-border-solid'
          >
            <button
              type='button'
              className='tw-flex lg:tw-block tw-h-16 tw-text-white lg:tw-text-text tw-mx-3 lg:tw-mx-6 lg:tw-pr-4 hover:tw-text-secondary lg:hover:tw-text-text'
              onClick={() => {
                setUserMenuOpen(false)
                setCompanyMenuOpen(!companyMenuOpen)
              }}
            >
              <div className='tw-hidden lg:tw-block'>
                <CardUser
                  logo={logoAsBase64}
                  companyName={razonSocial ?? ""}
                  initials={razonSocial?.substring(0, 2).toUpperCase()}
                  userName={`${persona?.nombre ?? ""} ${
                    persona?.apellidos ?? ""
                  }`}
                  showIconAngle
                  iconAngleTailwind={
                    companyMenuOpen
                      ? "tw-rotate-90 tw-transition-all tw-duration-200"
                      : "tw-rotate-0 tw-transition-all tw-duration-200"
                  }
                  action={false}
                />
              </div>
              <FontAwesomeIcon
                icon={["fal", "building"]}
                className='lg:tw-hidden tw-self-center tw-w-5 tw-h-5 tw-px-2 lg:tw-px-0 tw-text-simple'
              />
            </button>
            <div
              id='userMenuListCompanies'
              className={`${
                !companyMenuOpen ? "tw-hidden" : ""
              } tw-bg-white tw-absolute tw-top-20 tw-right-12 lg:tw-right-20 tw-z-50 tw-w-96 tw-pb-2 tw-h-fit tw-bg-erp-simple tw-border tw-border-solid tw-rounded-lg [&>*:last-child]:!tw-max-h-100`}
            >
              <div className='tw-px-3 tw-py-4 tw-border-b tw-border-solid lg:tw-hidden'>
                <CardUser
                  logo={logoAsBase64}
                  companyName={razonSocial ?? ""}
                  initials={razonSocial?.substring(0, 2).toUpperCase()}
                  userName={`${persona?.nombre} ${persona?.apellidos}`}
                  showIconAngle={false}
                  action={() => undefined}
                />
              </div>
              <NavbarAsesoria />
            </div>
          </div>

          <div
            ref={userMenuRef}
            className='tw-h-16'
          >
            <button
              type='button'
              className='tw-flex tw-justify-center tw-h-full tw-mr-3 lg:tw-mr-0 tw-text-white lg:tw-text-primary hover:tw-text-secondary tw-bg-transparent tw-border-0 lg:tw-px-[27.25px] tw-cursor-pointer'
              onClick={() => {
                setCompanyMenuOpen(false)
                setUserMenuOpen(!userMenuOpen)
              }}
            >
              <FontAwesomeIcon
                icon={["fal", "user"]}
                className='tw-self-center tw-w-5 tw-h-5 tw-px-2 lg:tw-px-0 tw-text-simple'
              />
            </button>
            <div
              onClick={() => setUserMenuOpen(false)}
              className={`${
                !userMenuOpen ? "tw-hidden" : ""
              } tw-bg-white tw-absolute tw-top-20 tw-right-3 sm:tw-right-5 tw-z-50 tw-w-64 tw-h-fit tw-bg-erp-simple tw-border tw-border-solid tw-rounded-lg`}
            >
              <ListMenu
                sectionList={USER_MENU_LIST(
                  goTo,
                  pathname,
                  isGestoriaEnabled,
                  setManageModalAsesoriaActiva,
                  setShowModalCierreContable,
                  asesoria?.invitacionId
                )}
              />
              <div
                className='tw-flex tw-w-full tw-px-6 tw-py-4 tw-border-t tw-border-solid tw-cursor-pointer hover:tw-text-white tw-text-danger hover:tw-bg-danger tw-rounded-b-lg tw-transition-colors tw-duration-300'
                onClick={() => {
                  dispatch(logout())
                }}
              >
                <FontAwesomeIcon
                  icon={["fal", "arrow-right-from-bracket"]}
                  className='tw-self-center tw-h-5'
                />
                <p className='tw-px-2 tw-m-0 tw-items-center tw-text-base'>
                  {t("header.logOff")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastIntegraciones
        isVisible={visibleToast}
        handleCloseToast={handleCloseToast}
      />
      <SendBusinessInvitation
        setInvitation={setInvitation}
        visible={openInvitation}
        showCompleteModal={setCompleteInvitation}
      />
      <SuccessModal
        visible={completeInvitation}
        setInvitation={setCompleteInvitation}
      />
      <ModalAsesoriaActiva
        isOpen={manageModalAsesoriaActiva.showModalAsesoria}
        onCloseModal={() =>
          setManageModalAsesoriaActiva({
            showModalAsesoria: false,
            deleteAsesoria: false,
          })
        }
        onDeleteAsesoria={handleConfirmAsesoria}
        setShowModalInvitacionesAsesoria={setShowModalInvitacionesAsesoria}
        asesoriaActiva={asesoria}
        setShowModalNoHayInvitacionesAsesoria={
          setShowModalNoHayInvitacionesAsesoria
        }
        manageModalAsesoriaActiva={manageModalAsesoriaActiva}
        setManageModalAsesoriaActiva={setManageModalAsesoriaActiva}
        totalInvitacionesAsesoria={invitacionesAsesoria?.totalCount}
      />

      <ModalNoHayInvitacionesAsesorias
        isOpen={showModalNoHayInvitacionesAsesoria}
        onConfirm={() => setShowModalNoHayInvitacionesAsesoria(false)}
      />

      <ModalInvitacionesAsesorias
        isOpen={showModalInvitacionesAsesoria}
        onCloseModal={() => setShowModalInvitacionesAsesoria(false)}
        onConfirmAsesoria={handleConfirmAsesoria}
        data={asesoriasInvitacionesAdapter(invitacionesAsesoria?.items ?? [])}
        asesoriaActiva={asesoria}
        setManageModalAsesoriaActiva={setManageModalAsesoriaActiva}
      />
      <ModalCierreContable
        showModalCierreContable={showModalCierreContable}
        onCancel={() => setShowModalCierreContable(false)}
      />
    </>
  )
}

export default NavBarRegistred
